module.exports = __webpack_public_path__ + "img/icon_info.9030e023.svg";